import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import Header from '../components/Header'
import wifi from '../assets/Group-19574.svg'
import play from '../assets/246462018fb1fdde4d60e0869a01238d.svg'
import message from '../assets/Group-19575.svg'
import Mockup from '../components/Mockup'
import Banner_2 from '../assets/homepage-web-view-1536x864.png'
import bike from '../assets/Group-20072.png'
import videoFile from '../assets/Video-Games-Box.mp4'
import Footer from '../components/Footer'
import { Check, CreditCard, Download } from 'lucide-react';



export default function Home() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [subscribeLink, setSubscribeLink] = useState('');
  const [country, setCountry] = useState(null);

  useEffect(() => {
    if (window.AOS) {
      window.AOS.init({ duration: 500 });
    }

    // Get saved country from session storage
    const savedCountry = sessionStorage.getItem("gamesbox-country-code");

    fetch(`https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry`)
      .then(response => response.text())
      .then(result => {
        console.log('User country:', result);
        const countryUpper = result.toUpperCase();
        
        // GetCountry has priority - update if different from saved value
        if (!savedCountry || savedCountry.toUpperCase() !== countryUpper) {
          sessionStorage.setItem("gamesbox-country-code", countryUpper);
        }
        
        setCountry(countryUpper);

        if (countryUpper === "BD") {
          // Bangladesh — special flow
          const bdSubscribeLink = "https://lp.games-box.mobi/?deviceId=67384657482647&country=bd&mbidbundle=10016&mbidoffer=15734";
          setSubscribeLink(bdSubscribeLink);
          sessionStorage.setItem("gamesbox-bd-subscribe-link", bdSubscribeLink);
        } else {
          // Default flow
          setSubscribeLink("https://publisherads.click/?SMCampaign=4b76ea47-f7f4-4557-8548-181e76406142&ClickID=YOUR_CLICK_ID&Pub_ID=YOUR_PUB_ID&Aff_ID=YOUR_AFF_ID&extra=YOUR_Dynamic_Parameter_IF_Needed&extra1=YOUR_Dynamic_Parameter_IF_Needed&utm_source=affiliate&utm_medium=cpc&utm_campaign={campaignid}&utm_content={adgroupid}&utm_term={keyword}&country=null&themeid=3&portal=GamesBox");
        }

        setLoading(false);
      })
      .catch(err => {
        console.error('Country fetch failed:', err);
        // Fallback to saved country if available
        const fallbackCountry = savedCountry ? savedCountry.toUpperCase() : "default";
        setCountry(fallbackCountry);
        setSubscribeLink("https://publisherads.click/?SMCampaign=4b76ea47-f7f4-4557-8548-181e76406142&ClickID=YOUR_CLICK_ID&Pub_ID=YOUR_PUB_ID&Aff_ID=YOUR_AFF_ID&extra=YOUR_Dynamic_Parameter_IF_Needed&extra1=YOUR_Dynamic_Parameter_IF_Needed&utm_source=affiliate&utm_medium=cpc&utm_campaign={campaignid}&utm_content={adgroupid}&utm_term={keyword}&country=null&themeid=3&portal=GamesBox");
        setLoading(false);
      });
  }, []);


  if (loading) return null;

  const isBD = country === "BD";
  const isFR = country === "FR";




  return (
    <div>
      <Header />
      <section >
        <div className='video_banner'  >


          <video
            className="d-block"
            autoPlay
            muted
            loop
            playsInline
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          >
            <source src={videoFile} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <div className='video_banner_inner' >

            <div className='text-center'>
              <h2>{t('home.unlimitedFunAwaits')}</h2>
              <h2 className='bold'>{t('home.diveIntoOver100Games')}</h2>
              <p>{t('home.yourPassToAdventures')}</p>

                <div>
              {!isBD && !isFR && <p className='bold'>{t('home.startingPrice')}</p>}

              

                   {!isBD && (
                  <a className='btn btn-primary' href='#DownloadSection'>
                    {t('home.downloadApp')} <Download size={23} />
                  </a>
                )}

                {/* Subscribe button — hidden for FR */}
                {!isFR && (
                  <a
                    id='subscribebutton'
                    className='btn btn-primary'
                    href={subscribeLink}
                    target='_blank'
                    rel='noreferrer'
                  >
                    {t('home.subscribeNow')} <CreditCard size={23} />
                  </a>
                )}
                </div>
            </div>


          </div>
        </div>
      </section>

      <section className='container my-4' >
        <div className='d-flex flex-column align-items-center justify-content-center' >
          <h2 className='my-4'>{t('home.instantAccess')}</h2>

          <div className='d-flex flex-row justify-content-center flex-wrap gap-4'

          >

            <div data-aos="zoom-in" className='home_card' >
              <img className='mb-2' src={wifi} alt="offline access" />
              <h3 className='mb-2'>{t('home.offlineAccess')}</h3>
              <p>{t('home.offlineAccessDesc')}</p>
            </div>

            <div data-aos="zoom-in" className='home_card' >
              <img className='mb-2' src={play} alt="play game" />
              <h3 className='mb-2'>{t('home.playAnywhere')}</h3>
              <p>{t('home.playAnywhereDesc')}</p>
            </div>

            <div data-aos="zoom-in" className='home_card' >
              <img className='mb-2' src={message} alt="global playground" />
              <h3 className='mb-2'>{t('home.globalPlayground')}</h3>
              <p>{t('home.globalPlaygroundDesc')}</p>
            </div>

          </div>
        </div>
      </section>

      <Mockup />


      <section className='my-7'>
        <div className='container text-center' data-aos="zoom-in">
          <h1>{t('home.gameLibraryParadise')}</h1>
          <h1>{t('home.discoverCountlessGames')}</h1>
          <p className='my-4' >{t('home.gameLibraryDesc')}</p>
        </div>

        <img data-aos="zoom-in" alt="html5 games" src={Banner_2} width={'100%'} style={{ height: '100vh', objectFit: 'cover' }} />
      </section>


      <section className='container my-7 icon-boxes-section' >
        <div className='row'>
          <div className='col-lg-6' >
            <img data-aos="zoom-out" src={bike} width={'90%'} style={{ margin: 'auto' }} alt="motorcycle games" />
          </div>
          <div className='col-lg-6 mt-3' >

            <div data-aos="zoom-in" className='d-flex flex-column justify-content-center align-items-start' style={{ height: '100%' }}>
              <h2 className='text-red bold mb-4' >{t('home.levelUpYourPlay')}</h2>

              <div className='d-flex flex-column gap-3 mb-3' >
                <div className='iconbox' > <Check /> <p>{t('home.unlimitedAccess')}</p></div>
                <div className='iconbox' > <Check /> <p>{t('home.noInstallNeeded')}</p></div>
                <div className='iconbox' > <Check /> <p>{t('home.findFast')}</p></div>
                <div className='iconbox' > <Check /> <p>{t('home.searchEasy')}</p></div>
                <div className='iconbox' > <Check /> <p>{t('home.multilingualSupport')}</p></div>
                <div className='iconbox' > <Check /> <p>{t('home.addToFavorites')}</p></div>
              </div>
              {!isFR && (
                <a className='btn btn-primary mt-4' href='https://publisherads.click/?SMCampaign=4b76ea47-f7f4-4557-8548-181e76406142&ClickID=YOUR_CLICK_ID&Pub_ID=YOUR_PUB_ID&Aff_ID=YOUR_AFF_ID&extra=YOUR_Dynamic_Parameter_IF_Needed&extra1=YOUR_Dynamic_Parameter_IF_Needed&utm_source=affiliate&utm_medium=cpc&utm_campaign={campaignid}&utm_content={adgroupid}&utm_term={keyword}&country=null&themeid=3&portal=GamesBox'
                  target='_blank'>{t('home.subscribeNow')}</a>
              )}
            </div>

          </div>
        </div>
      </section>


      <section data-aos="zoom-in" className='container my-7' >
        <h2 className='text-center my-4' >{t('home.unboxYourQuestions')}</h2>
        <hr className='my-4'></hr>

        <div className="accordion" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
                {t('home.whatIsGamesBox')}
              </button>
            </h2>
            <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                {t('home.whatIsGamesBoxAnswer')}
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">
                {t('home.whatGamesCanIPlay')}
              </button>
            </h2>
            <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                {t('home.whatGamesCanIPlayAnswer')}
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
                {t('home.doINeedToDownload')}
              </button>
            </h2>
            <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                {t('home.doINeedToDownloadAnswer')}
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour">
                {t('home.whatHappensToFavorites')}
              </button>
            </h2>
            <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                {t('home.whatHappensToFavoritesAnswer')}
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive">
                {t('home.howDoICancel')}
              </button>
            </h2>
            <div id="collapseFive" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                {t('home.howDoICancelAnswer')}
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix">
                {t('home.ageRestriction')}
              </button>
            </h2>
            <div id="collapseSix" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                {t('home.ageRestrictionAnswer')}
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven">
                {t('home.compatibleDevices')}
              </button>
            </h2>
            <div id="collapseSeven" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                {t('home.compatibleDevicesAnswer')}
              </div>
            </div>
          </div>
        </div>

      </section>

      <Footer />

    </div >
  )
}
